import ServiceTileContainer from './service_tile_container';

const ServiceTile = ServiceTileContainer;
export default ServiceTile;
